export function changePageTitle(title) {
  window.document.title = `Syclus 2.0 - ${title}`;
}